import styles from "./navigation.module.css";

import { defaultConfiguration } from "@/libs/config";
import type { Section, ViewType } from "@/types";

import { Tabs } from "@mantine/core";

interface NavigationProps {
  navigate: (view: ViewType, id?: number) => void;
  sections?: Section[];
}

export const Navigation = ({
  navigate,
  sections = defaultConfiguration.sections,
}: NavigationProps) => {
  return (
    <nav className={styles.container}>
      <Tabs
        variant="none"
        defaultValue="home"
        radius="xl"
        styles={{
          root: {
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
          },
          tab: {
            textAlign: "center",
            backgroundColor: "transparent",
            border: "none",
            justifyContent: "center",
            alignItems: "center",
          },
          tabLabel: {
            alignItems: "center",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            textAlign: "center",
            gap: "5px",
          },
        }}
        classNames={{
          tab: styles.tab,
          list: styles.tabList,
        }}
      >
        <Tabs.List>
          {sections?.map((section) => (
            <Tabs.Tab
              key={section.id}
              value={section.id}
              onClick={() => navigate(section.id)}
              hidden={section.show}
            >
              <div>
                {section.icon}
                {section.title}
              </div>
            </Tabs.Tab>
          ))}
        </Tabs.List>
      </Tabs>
    </nav>
  );
};
